<template>
  <div id="box">
    <!-- <div class="headerBox"></div>
    <div class="main">
      <router-view></router-view>
    </div>
    <div class="footerBox"></div> -->
    <router-view class="page-container"></router-view>
    <van-tabbar route v-model="active" active-color="#FF5A40" inactive-color="#646464">
      <van-tabbar-item icon="wap-home" to="/">首页</van-tabbar-item>
      <!-- <van-tabbar-item icon="todo-list-o">任务</van-tabbar-item> -->
      <van-tabbar-item icon="manager" to="/personalCenter">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
export default {
  name: "basic-layout",
  data() {
    return {
      active: 0
    };
  }
};
</script>
<style lang="scss"></style>
